import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import arrawLeft from "../../../theme/assets/images/icon/arrow-left.svg"
import visionImg from "../../../assets/img/vision.png"
const { REACT_APP_BRANDURL } = process.env;

export default function OurVision() {
    const [visionData, setVisionData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchVisionData();
    }, []);

    const fetchVisionData = async () => {
        try {
            setLoading(true);
            const response = await postAPI('about-us/getBySection', { 
                page: 'ABOUT', 
                section_name: 'Our Vision' 
            });
            if (response?.status === 1 && response?.data) {
                setVisionData(response.data);
            }
        } catch (error) {
            console.error('Error fetching vision data:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // if (!visionData) {
    //     return null;
    // }

    return (
        <section className='mission vision'>
            <div className='container'>
                <div className='row justify-content-between'>
                    {/* <div className='col-lg-5 order-1 order-lg-1 mb-lg-0 mb-3 text-md-start text-center'>
                        <figure><img src={visionImg} className='img-fluid' alt="Our Vision" /></figure>
                    </div> */}
                    <div className='col-lg-12'>
                        <h3>Our Objectives</h3>
                        <p>The Objectives of the <strong>B E College </strong>Ex-Students' Club define the aims and purposes for which the Association has been established. They set out the guiding framework for the Club's social, cultural, educational, charitable, and administrative activities, and govern the manner in which its resources are applied.</p>
                        <p><strong>The objectives of the Club are :-</strong></p>
                        <ul>
                            <li>To promote, arrange and organize social, cultural and other welfare activities with a view to fostering a spirit of friendliness, understanding and co-operating amongst the members and their families .</li>
                            <li>To devise ways and means to work for the well-being of the community as a whole and the B E College Alumni in particular.</li>
                            <li>To provide a forum for exchange of technical information.</li>
                            <li>To arrange and organize lectures, debates, discussions, seminars etc. for the diffusion of knowledge .</li>
                            <li>To engage and/or assist in any charitable and philanthrophic activities for alleviation of the sufferings of human beings or other living creatures as may be deemed appropriate.</li>
                            <li>To collect subscription and accept gifts and donations for any of the purposes of the Club from its well wishers.</li>
                            <li>To borrow money from Banks and/or other recognized financial institutions as may be necessary for carrying out any of the purposes of the Club.</li>
                            <li>To acquire suitable land and construct, maintain, develop and alter any building or house as may be necessary for the purpose of the club.</li>
                            <li>To publish or cause to be published useful bulletins, papers, magazines, books etc.</li>
                            <li>To do all such things as may be deemed incidental or conductive to and/or necessary for achieving the foregoing objectives,
The income and properties of the Club from whatever source derived or obtained shall be applied solely towards promotion of the objects of the Club and no portion thereof shall be paid to or divided amongst any of its members by way of profits. Provided that nothing herein contained shall prevent the payment in good faith of remuneration of any officers or servants or employees of the Club or other person in return for any service rendered to the Club.</li>
                        </ul>
                </div>
            </div>
            </div>
        </section>
    )
}
